// production
// var config = {id: 'IsqV9oNn0Qf14oTG8VeQjnEo-gzGzoHsz', key: 'OLLDSIaSPh9CkzhKzF8RY6nE'};

// dev
var config = {id: 'VHrrV6epV4rCBdlrYTDK2030-gzGzoHsz', key: 'WHexLAk1NpK2kXTpQvaL9VkT'};

module.exports = config;


/*****************
 ** WEBPACK FOOTER
 ** C:/Users/Administrator/Documents/GitHub/material-ui-vue/av.config.js
 ** module id = 42
 ** module chunks = 0
 **/